import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, ComboUf } from './types';

export const INITIAL_STATE: ComboUf = {
	status: 0,
	data: {
		processoId: '0',
		ufs: [],
	},
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ComboUf {
	return produce(state, draft => {
		switch (action.type) {
			case Types.COMBO_UF_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.COMBO_UF_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.COMBO_UF_FAILURE: {
				draft.status = action.payload.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
		return draft;
	});
}
